import React, { useState, useEffect, useContext, useMemo } from "react";
import _ from "lodash";
import { Container, Col, Row, Card, Modal } from "react-bootstrap";
import AddIcon from "@material-ui/icons/Add";
import JobUtils from "../../utils/JobsUtils";
import ConfigUtils from "../../utils/ConfigUtils";
import { RequestContext } from "../../context/RequestContext";
import DeliveryDropArea from "../drag-drop/DeliveryDropArea";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import { FieldTypes, JobKeys } from "../../constants/FieldTypes";
import '../../styles/card.scss';

const Delivery = () => {
  const deliveryType = ConfigUtils.getDeliveryTypes();
  const processorTypes = ConfigUtils.getProcessorTypes();
  const inputComponents = ConfigUtils.getInputComponents();
  const metadata = _.get(inputComponents, "inputComponents[0].dataFields[0]");

  const {
    _setSelectedDelivery,
    _setShowDeliveryForm,
    deleteDelivery,
    addNewDelivery,
    sourceLocation,
    jobType,
    sources,
    processes,
    deliveriesToSourceMapping,
    _setDeliveriesToSourceMapping,
    jobKeysToFilename,
    deliveries,
    stitchAssetName,
    isStitch,
    unmappedDeliveryKeys,
    setEventDeliveryFlag,
    deliveryMetadataKey,
    _setDeliveryMetadataKey
  } = useContext(RequestContext);
  const isScreenersDotCom = useMemo(() => _.get(jobType, "label", "") === "Screeners.com", [jobType]);
  const [deliveryFields, setDeliveryFields] = useState([]);
  const [dependencyArray, setDependencyArray] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);

  useEffect(() => {
    if (JobUtils.extractJobTypeProperty(jobType, "jobType") === "EVENT_SCREENERS") {
      let processTypes = JobUtils.extractProcessType(jobType);
      if (!_.isEmpty(processTypes)) {
        let delMethods = _.filter(processorTypes, (processType) => {
          return _.includes(processTypes, _.get(processType, "ref"));
        });
        let dependencyArrayTemp = [];
        _.map(delMethods, (method) => {
          let methodsArray = _.get(method, "fixedDeliveryMethods");
          let depObject = { key: _.get(method, "ref"), allowedMethods: methodsArray };
          dependencyArrayTemp.push(depObject);
        });
        setDependencyArray(dependencyArrayTemp);
      }
    }
    let deliveryMethods = _.get(jobType, "deliveryMethods");
    let delFields = _.map(deliveryMethods, (method) => {
      return _.find(deliveryType, (type) => {
        return _.get(type, "ref") === method;
      });
    });
    setDeliveryFields(delFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobType]);

  useEffect(() => {
    let deliveryMethods = _.get(jobType, "deliveryMethods");
    let delFields = _.map(deliveryMethods, (method) => {
      return _.find(deliveryType, (type) => {
        return _.get(type, "ref") === method;
      });
    });
    let newDeliveryMetadataKey = {};
    _.map(deliveries, (delivery) => {
      const deliveryOptionObject = _.get(delivery, "deliveryOption");
      let findLabel = _.find(delFields, (option) => {
        return option.label === deliveryOptionObject || option.ref === deliveryOptionObject;
      });
      // Setting deliver metadata key order
      const keyLabel = _.get(findLabel, "label")
      const keyOrder = _.get(findLabel, "metadata")
      newDeliveryMetadataKey = {...newDeliveryMetadataKey, [keyLabel]: ["deliveryOption", ...keyOrder]}
    });
    _setDeliveryMetadataKey(newDeliveryMetadataKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveries]);

  const handleEdit = (delivery) => {
    _setSelectedDelivery(delivery);
    _setShowDeliveryForm(true);
  };

  const handleCopy = (delivery) => {
    if (isScreenersDotCom) {
      setShowWarningModal(true);
      return;
    }
    addNewDelivery(_.omit(delivery, "key"));
  };

  const handleDelete = (delivery) => {
    deleteDelivery(delivery);
  };

  const getFieldValue = (metadataField, value) => {
    let fieldType = _.get(metadataField, "type");
    if (fieldType === FieldTypes.BOOLEAN) {
      return value === true ? "Yes" : "No";
    } else if (fieldType === FieldTypes.ARRAY) {
      return "" + value.length;
    }
    if (_.get(metadataField, "label") === "Drive Formatting" && value === "Windows (FAT32)") {
      return "Windows (NTFS)";
    }
    return value;
  }
  
  const onSourceDragged = (sourcesArray, process, delivery) => {
    let array = [], invalidDelivery = [];
    _.map(sourcesArray, (source) => {
      if (process) {
        if (_.isArray(process) && _.size(process) > 0) {
          _.map(process, (p) => {
            let deliveryOption = JobUtils.getDeliveryRefByDeliveryType(deliveryFields, _.get(delivery, "deliveryOption"));
            let validAddition = true;
            //Check for allowed processes with delivery
            if (!_.isEmpty(dependencyArray) && !_.isEmpty(p) && !_.isEmpty(deliveryOption)) {
              let dependency = _.find(dependencyArray, (item) => _.get(item, "key") === _.get(p, "screenerType"));
              //If not included in allowedMethods then discard entry
              if (!_.includes(_.get(dependency, "allowedMethods"), deliveryOption)) {
                validAddition = false;
                invalidDelivery = _.union([_.get(p, "screenerType", '')], invalidDelivery);
              }
            }
            if (validAddition) {
              let record = {
                sourceKey: _.get(source, "key"),
                deliveryKey: _.get(delivery, "key"),
                processKey: _.get(p, "key"),
              };
              array.push(record);
            }
          });
          if (_.size(invalidDelivery) > 0) {
            let screenerKey = _.size(invalidDelivery) > 1 ? 'multiple' : _.first(invalidDelivery);
            setEventDeliveryFlag({ key: screenerKey, selected: _.get(delivery, "deliveryOption") })
          }
        } else {
          let record = {
            sourceKey: _.get(source, "key"),
            deliveryKey: _.get(delivery, "key"),
            processKey: _.get(process, "key"),
          };
          array.push(record);
        }
      } else {
        let record = {
          sourceKey: _.get(source, "key"),
          deliveryKey: _.get(delivery, "key"),
        };
        array.push(record);
      }
    });
    handleSourcesMapping(array);
  };


  const handleSourcesMapping = (mappingList) => {
    let newMapping = { ...deliveriesToSourceMapping };
    _.map(mappingList, (mapping) => {
      let sourceKey = _.get(mapping, JobKeys.SOURCE);
      let deliveryKey = _.get(mapping, JobKeys.DELIVERY);
      let processKey = _.get(mapping, JobKeys.PROCESS);
      let key = !_.isNil(processKey) && processKey > -1 ? "" + sourceKey + "_" + processKey
        : sourceKey;
      if (newMapping[key]) {
        if (!newMapping[key].includes(deliveryKey)) {
          newMapping[key].push(deliveryKey);
        }
      } else {
        newMapping[key] = [deliveryKey];
      }
    });
    _setDeliveriesToSourceMapping(newMapping);
  };

  const handleSourceDeleted = (source, process, delivery) => {
    let deliveryKey = _.get(delivery, "key");
    let newMapping = { ...deliveriesToSourceMapping };
    let key = process ? _.get(source, "key") + "_" + _.get(process, "key")
      : _.get(source, "key");
    let sourceMapping = newMapping[key];
    let updatedMappingArray = _.filter(sourceMapping, (item) => {
      return item !== deliveryKey;
    });
    if (updatedMappingArray && updatedMappingArray.length === 0) {
      delete newMapping[key];
    } else {
      newMapping[key] = updatedMappingArray;
    }
    _setDeliveriesToSourceMapping(newMapping);
  };

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isScreenersDotCom && deliveries && deliveries.length >= 1) {
      setShowWarningModal(true);
      return;
    }
    _setShowDeliveryForm(true);
  }

  return (
    <Container className="m-0">
      <Modal className="modal"
        backdrop="static"
        size="lg"
        centered
        dialogClassName="modalDialog"
        show={showWarningModal}>
        <Modal.Header className="modalHeader">
          <Modal.Title className="modalHeaderTitle">Submission Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <p>This request only supports 1 delivery method(s) per job. One or more jobs dragged have reached their delivery limit.</p>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'flex-end' }}>
          <StyledBlueButton
            style={{ minWidth: "150px" }}
            onClick={() => {
              setShowWarningModal(false);
            }}
            variant="danger"
          >
            OK
          </StyledBlueButton>
        </Modal.Footer>
      </Modal>
      <Row className="headerRow">
        <label className="headerLabel">Deliveries</label>
      </Row>
      <Row>
        <StyledBlueButton
          className="m-0"
          variant="contained"
          onClick={handleAdd}>
          <AddIcon></AddIcon><span>Add a Delivery</span>
        </StyledBlueButton>
      </Row>
      {!_.isEmpty(deliveries) ? (
        <Row>
          <Container fluid className="deliveryContainer">
            {_.map(deliveries, (delivery, index) => {
              const sortedDelivery = JobUtils.sortDelivery(delivery, deliveryMetadataKey);
              return (
                <Card className="cardContainer" key={"delivery" + index}>
                  <Card.Body className="deliveryCardBody">
                    {_.map(sortedDelivery, (value, key) => {
                      let metadataField = _.get(metadata, key);
                      if (!value || !metadataField || _.get(metadataField, "hideFromUI")) {
                        return null;
                      }
                      return (
                        <Row className="cardRow" key={"row" + key}>
                          <label className="cardLabel">{_.get(metadataField, "label") + ":"}</label>
                          <span className="cardText">{getFieldValue(metadataField, value)}</span>
                        </Row>
                      );
                    })}
                    <Row xs={12}>
                      <Col className="fullWidth">
                        <DeliveryDropArea
                          jobType={jobType}
                          sourceLocation={sourceLocation}
                          sourceList={sources}
                          processList={processes}
                          index={_.get(delivery, "key")}
                          deliveryOption={JobUtils.getDeliveryRefByDeliveryType(deliveryFields, _.get(delivery, "deliveryOption"))}
                          onSourceDragged={(draggedSources, process) => {
                            onSourceDragged(draggedSources, process, delivery);
                          }}
                          handleSourceDelete={(source, process) => handleSourceDeleted(source, process, delivery)}
                          jobKeysToFilename={jobKeysToFilename}
                          deliveriesToSourceMapping={deliveriesToSourceMapping}
                          dependencyArray={dependencyArray}
                          isStitch={isStitch}
                          stitchAssetName={stitchAssetName}
                          isUnmapped={unmappedDeliveryKeys.has(_.get(delivery, "key"))}
                          setEventDeliveryFlag={(obj) => { setEventDeliveryFlag({ ...obj, selected: _.get(delivery, "deliveryOption") }) }}
                        />
                      </Col>
                    </Row>
                  </Card.Body>

                  <Card.Footer className="cardFooter">
                    <Row className="deliveryCardButtonRow">
                      <StyledBlueButton
                        className="deliveryCardButton"
                        id={"edit"}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleEdit(delivery);
                        }}>
                        Edit
                      </StyledBlueButton>
                      <StyledBlueButton
                        className="deliveryCardButton"
                        id={"copy"}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleCopy(delivery);
                        }}>
                        Copy
                      </StyledBlueButton>
                      <StyledBlueButton
                        className="deliveryCardButton"
                        id={"delete"}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleDelete(delivery);
                        }}>
                        Delete
                      </StyledBlueButton>
                    </Row>
                  </Card.Footer>
                </Card>
              )
            })}
          </Container>
        </Row>
      ) : null}
    </Container>
  );
};

export default React.memo(Delivery);
